"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REMOVE_TOAST = exports.ADD_TOAST = void 0;
exports["default"] = reducer; // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//

var ADD_TOAST = 'add';
exports.ADD_TOAST = ADD_TOAST;
var REMOVE_TOAST = 'remove';
exports.REMOVE_TOAST = REMOVE_TOAST;

function reducer(toastMap, action) {
  switch (action.type) {
    case ADD_TOAST:
      return new Map(toastMap.set(action.key, action.toast));

    case REMOVE_TOAST:
      toastMap["delete"](action.key);
      return new Map(toastMap);

    default:
      throw new Error("Wrong action type \"".concat(action.type, "\" for toast reducer"));
  }
}